import React from "react";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import styles from "./Page.module.scss";

export default ({ children }) => {
  const location = useLocation();
  const theme = useTheme();
  // Same breakpoint Navigationbar.jsx switches on.
  const largeScreen = useMediaQuery(theme.breakpoints.up("md"));
  // Setlist template management still gets its own chrome-less
  // back-button page (no top-bar clearance needed) on mobile, which has
  // no bottom-tab entry for it - but on desktop it now renders under
  // the persistent Navigationbar like any other normal page (see the
  // matching fix in Navigationbar.jsx's isFullScreenPage), so it needs
  // the standard top clearance there instead of none.
  const no_chrome_paths =
    (location.pathname === "/login") |
    location.pathname.startsWith("/password-reset/confirm/") |
    location.pathname.startsWith("/events/") |
    location.pathname.startsWith("/songs/") |
    (!largeScreen && location.pathname.startsWith("/setlist-templates"));
  const className = no_chrome_paths ? "" : styles.pageContent;
  return <div className={className}>{children}</div>;
};
